import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyRadioCheck(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);

    const [value, setValue] = useState('');
    const [remark, setRemark] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [mode, setMode] = useState(props?.mode);
    const [answerMapping, setMap] = useState(props?.answerMapping)

    const handleChange = (event) => {
        setValue(event.target.value);
        const selectedValue = event.target.value;
        setRemark('');
        const option = question.optionList.find((option) => option.id == selectedValue);
        setSelectedOption(option);
        handleSubmit(option);
    };

    const handleRemarkChange = (event) => {
        setRemark(event.target.value);
    };

    const handleSubmit = (option) => {
        var payload = {
            id: question.id
        };

        if (option) {
            payload = {
                id: question.id,
                answerList: [
                    {
                        questionOptionId: option.id,
                        remark: option.showRemark ? remark : '',
                    }
                ]
            };
        }

        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };

    return (
        mode !== 1
            ?
            <>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={handleChange}
                    required={question.questionMandatory}
                >
                    {question.optionList.map((radioOption) => (
                        <>
                            <FormControlLabel
                                key={radioOption.id}
                                value={radioOption.id}
                                control={<Radio color="success" />}
                                label={radioOption.name}
                                id={"question-id-" + question.id + "-option-id-" + radioOption.id}
                                className={"question-id-" + question.id + "-option-id-" + radioOption.id}
                                name={"questionList[" + question.questionSequenceNo + "].answerList[" + radioOption.optionSequenceNo + "].questionOptionId"}
                            />
                        </>
                    ))}
                </RadioGroup>
                {selectedOption && selectedOption.showRemark && (
                    <Form.Control as="textarea"
                        id={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
                        className={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
                        name={"questionList[" + question.questionSequenceNo + "].answerList[" + selectedOption.optionSequenceNo + "].remark"}
                        placeholder="Remark"
                        variant="outlined"
                        value={remark}
                        onChange={handleRemarkChange}
                        onBlur={() => handleSubmit(selectedOption)} // Add onBlur event to submit the payload when the user finishes typing
                    />
                )}
               </> : <>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={null}
                    onChange={() => { }}
                    required={question.questionMandatory}
                >
                    {question.optionList.map((radioOption) => {
                        debugger
                        return <>
                            <FormControlLabel
                                key={radioOption.id}
                                value={radioOption.id}
                                control={<Radio sx={() => {
                                    debugger; return answerMapping[0].answerId === radioOption.id || props?.correct[0].answerid === radioOption.id ?
                                        props?.correct[0].answerid === radioOption.id ? {
                                            color: '#4CAF50',
                                            '&.Mui-checked': {
                                                color: '#4CAF50',
                                            },
                                        } : {

                                            color: '#ffa023',
                                            '&.Mui-checked': {
                                                color: '#ffa023',
                                            },
                                        } : {
                                            color: '#F44336',
                                            '&.Mui-checked': {
                                                color: '#F44336',
                                            },
                                        }
                                }} />}
                                label={(<span style={{ color: answerMapping[0].answerId === radioOption.id || props?.correct[0].answerid === radioOption.id ? props?.correct[0].answerid === radioOption.id ? "#4CAF50" : "#F44336" : "black" }}>{radioOption.name}</span>)}
                                id={"question-id-" + question.id + "-option-id-" + radioOption.id}
                                className={"question-id-" + question.id + "-option-id-" + radioOption.id}
                                name={"questionList[" + question.questionSequenceNo + "].answerList[" + radioOption.optionSequenceNo + "].questionOptionId"}
                            />
                        </>
                    })}
                </RadioGroup>
            </>
    );
}
